import Rete from "rete";
import { StockDataSocket,StockDataListControl } from "../../rete-controls/StockDataListControl.js"
import InMemoryStockData from "../../../Utils/InMemoryStockData.js"
import DataBaseNode from "../../rete-custom-nodes/DatabaseNode.vue"
export default class StockDataListComponent extends Rete.Component {
    constructor(){
        super("StockDataListComponent"); // name
        this.stockData = InMemoryStockData.getStockData();
        this.data.component = DataBaseNode;
        this._categories = ["Input Nodes","Stock Nodes", "tryMe"];
    }

    builder(node) {
        let out1 = new Rete.Output('out1','StockData',StockDataSocket);
        let opControl = new StockDataListControl(this.editor,"stockkey", this.stockData);

        return node
        .addOutput(out1)
        .addControl(opControl);
    }

    worker(node, inputs, outputs) {
        outputs['out1'] = this.stockData[node.data.stockkey];

       // console.log(this.name + " node.data= " + JSON.stringify(node.data));
       // console.log(this.name + " outputs= " + JSON.stringify(outputs));
    }
}

//ReteComponentStore.add(new OperationsComponent())

